// **********************************************************
// Toggle Modal
// **********************************************************

// Open Modal
attachEvent('.product-modal-trigger', 'click', (ev) => {
  const productModal = document.body.querySelector('.product-modal');
  productModal?.classList.add('is-open-modal');
  toggleBodyScrollLock(true);
  ev.preventDefault();
});

attachEvent('.form-modal-trigger', 'click', (ev) => {
  const formModal = document.body.querySelector('.form-modal');
  formModal?.classList.add('is-open-modal');
  toggleBodyScrollLock(true);
  ev.preventDefault();
});

// Close Modal
attachEvent('.modal__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.modal');
  parentEle.classList.remove('is-open-modal');
  toggleBodyScrollLock(false);
  ev.preventDefault();
});

onKeydown('escape', () => {
  const modalEle = document.querySelectorAll('.modal.is-open-modal');
  modalEle.forEach((el) => {
    el.classList.remove('is-open-modal');
    toggleBodyScrollLock(false);
  });
});
